import { render, staticRenderFns } from "./productOrderHeaderInfo.vue?vue&type=template&id=487c6538&scoped=true&"
import script from "./productOrderHeaderInfo.vue?vue&type=script&lang=js&"
export * from "./productOrderHeaderInfo.vue?vue&type=script&lang=js&"
import style0 from "./productOrderHeaderInfo.vue?vue&type=style&index=0&id=487c6538&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487c6538",
  null
  
)

export default component.exports